const benefits = [
  {
    num: '01',
    icon: 'ri-user-heart-line',
    title: 'Dein Trainer ist bei dir – von Minute eins.',
    text: 'Kein Selbstbedienungsstudio. Kein Plan, den du allein umsetzen musst. Jemand, der deinen Namen kennt, dein Ziel kennt – und beim nächsten Termin noch daran erinnert.',
    tag: '1:1-Betreuung',
  },
  {
    num: '02',
    icon: 'ri-time-line',
    title: '20 Minuten einmal die Woche. Das ist keine Vereinfachung.',
    text: 'EMS stimuliert mehr Muskelfasern in weniger Zeit als jedes klassische Training. Dein Körper braucht eine volle Woche zur Regeneration. Einmal pro Woche ist physiologisch optimal – nicht weniger.',
    tag: 'Zeiteffizienz',
  },
  {
    num: '03',
    icon: 'ri-shield-user-line',
    title: 'Kein Vergleich. Keine Blicke. Keine Scham.',
    text: 'Diskrete, ruhige Atmosphäre. Du trainierst persönlich – ohne Leistungsdruck, ohne andere Blicke, ohne den Stress anonymer Großstudios. So soll Training sein.',
    tag: 'Diskrete Atmosphäre',
  },
  {
    num: '04',
    icon: 'ri-heart-pulse-line',
    title: 'Kein Gewicht. Kein Gelenkstress.',
    text: 'Ideal bei Rücken- oder Knieproblemen, nach Verletzungen oder als sanfter Wiedereinstieg. EMS wirkt tief und effektiv – ohne das, was klassische Übungen an Gelenken fordern.',
    tag: 'Gelenkschonend',
  },
  {
    num: '05',
    icon: 'ri-sparkling-line',
    title: 'Ergebnisse, die man spürt – oft nach wenigen Wochen.',
    text: 'Straffere Konturen, mehr Energie, weniger Rückenbeschwerden. Unsere Kunden berichten erste Veränderungen häufig nach drei bis fünf Einheiten – nicht erst nach Monaten.',
    tag: 'Sichtbare Resultate',
  },
  {
    num: '06',
    icon: 'ri-map-pin-2-line',
    title: 'Parkplatz vor der Tür. Termin nach Vereinbarung.',
    text: 'Kein Stau, keine Parkplatzsuche, kein zufälliger Besuch. Du buchst, kommst, trainierst – und bist in 20 Minuten wieder fertig. Direkt in Pinneberg.',
    tag: 'Pinneberg · Unkompliziert',
  },
];

const targets = [
  { icon: 'ri-briefcase-4-line', label: 'Berufstätige mit wenig Zeit' },
  { icon: 'ri-seedling-line', label: 'Einsteiger ohne Vorkenntnisse' },
  { icon: 'ri-body-scan-line', label: 'Rücken- & Gelenkbeschwerden' },
  { icon: 'ri-scales-3-line', label: 'Figur- & Gewichtsziel' },
  { icon: 'ri-shield-user-line', label: 'Wunsch nach echter Betreuung' },
  { icon: 'ri-sparkling-line', label: 'Ab 40 neu anfangen' },
];

export default function BenefitsSection() {
  return (
    <section id="vorteile" className="py-24 md:py-32" style={{ backgroundColor: '#F4F7F5' }}>
      <div className="max-w-6xl mx-auto px-6">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <span
              className="text-xs font-medium tracking-[0.2em] uppercase"
              style={{ fontFamily: 'Inter, sans-serif', color: '#1A5C3D' }}
            >
              Was dich erwartet
            </span>
            <h2
              className="text-3xl md:text-5xl font-bold text-gray-900 mt-4 leading-tight"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              Kein Standard.<br />
              <span style={{ color: '#1A5C3D' }}>Kein Kompromiss.</span>
            </h2>
          </div>
          <p
            className="text-gray-400 text-sm md:text-base max-w-sm leading-relaxed"
            style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
          >
            Sechs Gründe, warum Körperformen Pinneberg sich von allem anderen unterscheidet.
          </p>
        </div>

        {/* Benefits grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px rounded-3xl overflow-hidden" style={{ backgroundColor: '#D8E8DE' }}>
          {benefits.map((b, i) => (
            <div
              key={i}
              className="bg-white hover:bg-gray-50/70 transition-colors duration-300 p-8 md:p-10 group"
            >
              <div className="flex items-start justify-between mb-5">
                <div className="flex items-center gap-3">
                  <span
                    className="text-3xl font-bold leading-none"
                    style={{ fontFamily: 'Playfair Display, serif', color: '#D5E5DB' }}
                  >
                    {b.num}
                  </span>
                  <div
                    className="w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0"
                    style={{ backgroundColor: 'rgba(26,92,61,0.07)' }}
                  >
                    <i className={`${b.icon} text-sm`} style={{ color: '#1A5C3D' }}></i>
                  </div>
                </div>
                <span
                  className="text-xs font-medium px-3 py-1.5 rounded-full border whitespace-nowrap"
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    color: '#1A5C3D',
                    borderColor: 'rgba(26,92,61,0.18)',
                    backgroundColor: 'rgba(26,92,61,0.05)',
                  }}
                >
                  {b.tag}
                </span>
              </div>
              <h3
                className="text-gray-900 font-semibold text-base leading-snug mb-2.5"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                {b.title}
              </h3>
              <p
                className="text-gray-500 text-sm leading-relaxed"
                style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
              >
                {b.text}
              </p>
            </div>
          ))}
        </div>

        {/* Target group box */}
        <div className="mt-8 rounded-3xl px-6 md:px-12 py-8 md:py-10" style={{ backgroundColor: '#1A5C3D' }}>
          <div className="flex flex-col gap-6 md:gap-7">
            <div>
              <h3
                className="text-white text-xl md:text-2xl font-semibold leading-snug"
                style={{ fontFamily: 'Playfair Display, serif' }}
              >
                Für wen ist das gemacht?
              </h3>
              <p
                className="text-sm mt-1.5"
                style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300, color: 'rgba(255,255,255,0.45)' }}
              >
                Erkennst du dich in einem davon?
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2.5">
              {targets.map((t, i) => (
                <div
                  key={i}
                  className="flex items-center gap-3 rounded-xl px-4 py-3"
                  style={{ backgroundColor: 'rgba(255,255,255,0.07)' }}
                >
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className={`${t.icon} text-sm`} style={{ color: '#6ED8A0' }}></i>
                  </div>
                  <span
                    className="text-sm leading-snug"
                    style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(255,255,255,0.75)' }}
                  >
                    {t.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
